var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-perm-contact-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7917 3.12508H18.75V1.04175H16.6667V3.12508H8.33333V1.04175H6.25V3.12508H5.20833C4.6558 3.12508 4.12589 3.34457 3.73519 3.73528C3.34449 4.12598 3.125 4.65588 3.125 5.20841V19.7917C3.125 20.3443 3.34449 20.8742 3.73519 21.2649C4.12589 21.6556 4.6558 21.8751 5.20833 21.8751H19.7917C20.9375 21.8751 21.875 20.9376 21.875 19.7917V5.20841C21.875 4.06258 20.9375 3.12508 19.7917 3.12508ZM12.5 6.25008C14.2292 6.25008 15.625 7.64591 15.625 9.37508C15.625 11.1042 14.2292 12.5001 12.5 12.5001C10.7708 12.5001 9.375 11.1042 9.375 9.37508C9.375 7.64591 10.7708 6.25008 12.5 6.25008ZM18.75 18.7501H6.25V17.7084C6.25 15.6251 10.4167 14.4792 12.5 14.4792C14.5833 14.4792 18.75 15.6251 18.75 17.7084V18.7501Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.b8c7ef7adadb3ed712eeab4726b08066.svg";
export { ForwardRef as ReactComponent };